import type Vue from 'vue'

import { useSweetAlert } from '@/common/composables/sweet-alert'
import type { ErrorHandler } from '@/common/lib/error-handlers/error-handler'

/**
 * Handle HTTP 503 error
 */
const handleServiceUnavailable: ErrorHandler = async (vue: Vue): Promise<void> => {
    const { showToast } = useSweetAlert()

    await showToast(vue.$t('errors.503').toString(), 'error')
}

export { handleServiceUnavailable }
